const shanyiJump = () => import("@/views/shanyiApp/appJump");

const routes = [
    {
        path: "/shanyiJump/:link",
        name: "ShinyEasy",
        meta: {
            title: "闪易"
        },
        component: shanyiJump
    },
];
export default routes;